import { Resource as ResourceType } from '../types';

export const payments: ResourceType = {
  name: 'payments',
  label: 'resource.invoices.section.payments.title',
  hideResource: true,
  attributes: [
    { key: 'id', type: 'text', label: 'ID' },
    { key: 'amount', type: 'number', label: 'payment.amount.total' },
    {
      key: 'partial_payment_date',
      type: 'date',
      label: 'resource.invoices.field.payment_date.label',
    },
    {
      key: 'invoice_id',
      type: 'text',
      label: 'resource.invoices.field.invoice_id.label',
    },
  ],
  pages: {
    list: {
      fields: [
        { source: 'id' },
        { source: 'amount' },
        { source: 'partial_payment_date' },
        { source: 'invoice_id' },
      ],
    },
  },
};
